// extracted by mini-css-extract-plugin
export default {"root":"_3a7LT","label":"_19D1K"};